"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var currentTransactionId = 0;

var getCurrentTransactionId = exports.getCurrentTransactionId = function getCurrentTransactionId() {
    return currentTransactionId;
};

var getNewTransactionId = exports.getNewTransactionId = function getNewTransactionId() {
    currentTransactionId++;
    return currentTransactionId;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/undoRedoTransactionManager.js
// module id = 86
// module chunks = 0